/**
 * Modular gate chip row — 4-col grid, short labels, pass/fail/na.
 * Tweak labels here without touching page layouts.
 */
export type GateState = boolean | null | undefined;

export function GateChip({
  passed,
  short,
  title,
}: {
  passed: GateState;
  short: string;
  title: string;
}) {
  const state = passed === true ? 'pass' : passed === false ? 'fail' : 'na';
  const mark = passed === true ? '✓' : passed === false ? '✕' : '·';
  return (
    <span className={`tc-mob-gate-chip tc-mob-gate-chip--${state}`} title={title}>
      <span className="tc-mob-gate-chip__mark" aria-hidden>
        {mark}
      </span>
      <span className="tc-mob-gate-chip__label">{short}</span>
    </span>
  );
}

export type CandidateGates = {
  macro?: GateState;
  liquidation_zone?: GateState;
  min_distance?: GateState;
  soft_score_ok?: GateState;
};

/** Standard DCD gate strip — swap order/labels in one place */
export function CandidateGateRow({ gates }: { gates: CandidateGates }) {
  return (
    <div className="tc-mob-card__gates" aria-label="Gate status">
      <GateChip passed={gates.macro} short="Macro" title="Gate macro / kalender" />
      <GateChip passed={gates.liquidation_zone} short="Liq" title="Gate zona likuidasi" />
      <GateChip passed={gates.min_distance} short="Dist" title="Gate jarak min ke strike" />
      <GateChip passed={gates.soft_score_ok} short="Score" title="Soft score" />
    </div>
  );
}
